import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "top",
  "use": "top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"top\"><path d=\"M7.293 2.707a1 1 0 0 1 1.414 0l3.586 3.586c.63.63.184 1.707-.707 1.707H4.414c-.89 0-1.337-1.077-.707-1.707z\" /><path d=\"M6 6h4v8H6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol